import Icon from "./IconBase.js";

const HidePasswordIcon = (props) => {
  return (
    <Icon width="20" height="12" viewBox="0 0 20 12" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M19.935 5.747C17.853 2.224 14.073.017 10 .017S2.143 2.223.065 5.746a.383.383 0 0 0 0 .424C2.147 9.694 5.927 11.902 10 11.902s7.857-2.208 9.935-5.73a.383.383 0 0 0 0-.425zM10 11.053A10.617 10.617 0 0 1 .955 5.96 10.617 10.617 0 0 1 10 .865c3.694 0 7.135 1.951 9.045 5.094A10.617 10.617 0 0 1 10 11.053z"
          fill="#00B0F5"
          fillRule="nonzero"
        />
        <path
          d="M10 2.139a3.805 3.805 0 0 0-3.82 3.82A3.805 3.805 0 0 0 10 9.78a3.805 3.805 0 0 0 3.82-3.82A3.805 3.805 0 0 0 10 2.14zm0 6.792a2.954 2.954 0 0 1-2.971-2.972A2.956 2.956 0 0 1 10 2.988a2.956 2.956 0 0 1 2.971 2.971A2.954 2.954 0 0 1 10 8.931z"
          fill="#00B0F5"
          fillRule="nonzero"
        />
        <path
          d="M10 4.261v.85c.465 0 .849.383.849.848a.854.854 0 0 1-.849.85.854.854 0 0 1-.849-.85h-.849c0 .935.763 1.698 1.698 1.698.935 0 1.698-.763 1.698-1.698 0-.935-.763-1.698-1.698-1.698z"
          fill="#00B0F5"
          fillRule="nonzero"
        />
        <path stroke="#00B0F5" strokeLinecap="round" d="m4 9.5 12-7" />
      </g>
    </Icon>
  );
};

export default HidePasswordIcon;
